module.exports = __webpack_public_path__ + "img/avatar4.cb172f92.png";